var render = function render(){
  var _vm$selectedProduct, _vm$selectedProduct2, _vm$selectedProduct3, _vm$selectedProduct4, _vm$selectedProduct5, _vm$selectedProduct6, _vm$selectedProduct7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "details-ctn pt-4 mr-4 pb-6"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-5 clickable",
    attrs: {
      "color": "black",
      "size": "24"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("mdi-arrow-left")]), _vm.selectedProduct ? _c('span', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s((_vm$selectedProduct = _vm.selectedProduct) === null || _vm$selectedProduct === void 0 ? void 0 : _vm$selectedProduct.product_name))]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex align-center mt-13",
    class: _vm.isProductConnected ? 'mb-4' : 'mb-6'
  }, [_c('span', {
    staticClass: "text-status mr-5 flex-shrink-0 w-160"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_connection_status')))]), _c('span', {
    staticClass: "text-capitalize text-wrap",
    class: _vm.isProductConnected ? 'text-connected' : 'text-failed'
  }, [_vm._v(" " + _vm._s((_vm$selectedProduct2 = _vm.selectedProduct) === null || _vm$selectedProduct2 === void 0 ? void 0 : _vm$selectedProduct2.status) + " ")])]), _vm.isProductConnected && _vm.isAllowed('amz_transparency_edit') ? _c('div', {
    staticClass: "d-flex align-center mb-6"
  }, [_c('v-switch', {
    staticClass: "flex-shrink-0 mr-5 w-160",
    attrs: {
      "label": ""
    },
    on: {
      "change": _vm.toggleSwitch
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "ml-4 font-weight-bold",
          staticStyle: {
            "color": "black"
          }
        }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_auto_upload')))])];
      },
      proxy: true
    }], null, false, 1275099078),
    model: {
      value: _vm.isAutoUpload,
      callback: function ($$v) {
        _vm.isAutoUpload = $$v;
      },
      expression: "isAutoUpload"
    }
  }), _c('span', {
    staticClass: "text-wrap text-auto-upload"
  }, [_vm._v(" " + _vm._s(_vm.$t('amazon_transparency_by_enabling')) + " \"" + _vm._s(_vm.$t('amazon_transparency_auto_upload')) + ",\" " + _vm._s(_vm.$t('amazon_transparency_qrcode_auto_upload')) + " ")])], 1) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "mt-6 mb-6"
  }, [_c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-10 font-weight-bold text-capitalize w-80 text-bold flex-shrink-0"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_product')))]), _c('span', {
    staticClass: "text-wrap"
  }, [_vm._v(_vm._s((_vm$selectedProduct3 = _vm.selectedProduct) === null || _vm$selectedProduct3 === void 0 ? void 0 : _vm$selectedProduct3.product_name))])])]), _c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-2 font-weight-bold text-capitalize text-bold w-80 flex-shrink-0"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_sku')))]), _c('span', {
    staticClass: "text-wrap"
  }, [_vm._v(_vm._s((_vm$selectedProduct4 = _vm.selectedProduct) === null || _vm$selectedProduct4 === void 0 ? void 0 : _vm$selectedProduct4.sku))])])])], 1), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "mr-10 font-weight-bold text-capitalize text-bold w-80 flex-shrink-0"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_gtin_14')))]), _c('span', {
    staticClass: "text-wrap"
  }, [_vm._v(_vm._s((_vm$selectedProduct5 = _vm.selectedProduct) === null || _vm$selectedProduct5 === void 0 ? void 0 : _vm$selectedProduct5.gtin))])])])], 1), _c('v-row', [_c('v-col', [(_vm$selectedProduct6 = _vm.selectedProduct) !== null && _vm$selectedProduct6 !== void 0 && _vm$selectedProduct6.description ? _c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "font-weight-bold text-capitalize text-bold w-80 mr-10 flex-shrink-0"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_remark')))]), _c('span', {
    staticClass: "text-break"
  }, [_vm._v(_vm._s((_vm$selectedProduct7 = _vm.selectedProduct) === null || _vm$selectedProduct7 === void 0 ? void 0 : _vm$selectedProduct7.description))])]) : _vm._e()])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "mt-6 d-flex align-center mb-4"
  }, [_c('span', {
    staticClass: "transactions-header-text"
  }, [_vm._v(_vm._s(_vm.$t('amazon_transparency_tbya_transactions')))]), _c('v-spacer'), _c('div', {
    staticClass: "d-flex align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "align-self-center mr-5",
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_vm._v("mdi-filter-variant")]), _c('v-select', {
    staticClass: "custom-status-select elevation-0",
    attrs: {
      "items": _vm.filterOptions,
      "item-disabled": _vm.isItemDisabled,
      "label": "Status",
      "dense": "",
      "solo": "",
      "height": "40"
    },
    model: {
      value: _vm.selectedStatus,
      callback: function ($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-5"
  }, [_c('v-data-table', {
    staticClass: "custom-transactions-table",
    attrs: {
      "headers": _vm.headers,
      "loading": _vm.isLoading,
      "items-per-page": 5,
      "items": _vm.productTransactions,
      "options": _vm.options,
      "server-items-length": _vm.totalProductTransactions,
      "footer-props": {
        'items-per-page-text': '',
        'disable-items-per-page': true
      },
      "item-value": "id",
      "loading-text": _vm.$t('amazon_transparency_loading_transactions'),
      "hide-default-footer": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.source",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v(_vm._s(item.source))])];
      }
    }, {
      key: "item.status",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', {
          staticClass: "text-capitalize",
          class: _vm.utils.getStatusStyle(item.status.toLowerCase())
        }, [_vm._v(" " + _vm._s(_vm.utils.transformStatusText(item.status)) + " ")])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex justify-end mt-5 mb-4"
        }, [_c('v-pagination', {
          staticClass: "flex-grow-0",
          attrs: {
            "length": _vm.totalPages,
            "total-visible": 7
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.options.page,
            callback: function ($$v) {
              _vm.$set(_vm.options, "page", $$v);
            },
            expression: "options.page"
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('auto-upload-confirmation-modal', {
    attrs: {
      "display-confirmation-modal": _vm.showConfirmationModal,
      "handle-cancel-btn": _vm.handleCancelBtn,
      "handle-disable-btn": _vm.handleDisableBtn,
      "handle-enable-btn": _vm.handleEnableBtn,
      "is-disabling": _vm.isDisablingAutoUpload
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }